import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // Sample gallery photos
  const photos = [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&fit=crop",
      alt: "Craft cocktail with garnish",
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1514362545857-3bc1c0d2fea5?w=400&fit=crop",
      alt: "Bartender mixing drinks",
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1546173159-315724a31696?w=400&fit=crop",
      alt: "Wedding reception bar setup",
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?w=400&fit=crop",
      alt: "Corporate event bartending",
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=400&fit=crop",
      alt: "Signature cocktail menu",
    },
    {
      id: 6,
      src: "https://images.unsplash.com/photo-1566733971017-fc4277d0b5c9?w=400&fit=crop",
      alt: "Premium spirits selection",
    },
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Craft Cocktails for Your
            <span className="gradient-text"> Special Events</span>
          </h1>
          <p className="hero-subtitle">
            Professional mobile bartending services that bring the bar to you.
            From intimate gatherings to large corporate events, we create
            unforgettable experiences.
          </p>
          <div className="hero-buttons">
            <Link to="/quote" className="btn btn-primary">
              Get Your Quote
            </Link>
            <Link to="/media" className="btn btn-secondary">
              View Our Work
            </Link>
          </div>
        </div>
        <div className="hero-image">
          <div className="floating-elements">
            <div className="floating-shape shape-1"></div>
            <div className="floating-shape shape-2"></div>
            <div className="floating-shape shape-3"></div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="scroll-indicator">
          <div className="scroll-arrow"></div>
          <p>Scroll to explore</p>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🍸</div>
              <h3>Private Parties</h3>
              <p>
                Intimate gatherings, birthdays, anniversaries, and special
                celebrations with personalized cocktail menus.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">🏢</div>
              <h3>Corporate Events</h3>
              <p>
                Professional bartending services for corporate functions,
                product launches, and business celebrations.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">💒</div>
              <h3>Weddings</h3>
              <p>
                Make your special day unforgettable with our premium wedding
                bartending services and signature cocktails.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">🎉</div>
              <h3>Large Events</h3>
              <p>
                From 50 to 500+ guests, we handle events of any size with
                multiple bartenders and full-service setup.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <div className="features-content">
            <div className="features-text">
              <h2>Why Choose Craft Cocktails?</h2>
              <ul className="features-list">
                <li>🎯 Custom cocktail menus tailored to your event</li>
                <li>👨‍🍳 Professional, licensed bartenders</li>
                <li>🍹 Premium spirits and fresh ingredients</li>
                <li>🚚 Full setup and cleanup included</li>
                <li>💼 Licensed and insured service</li>
                <li>⏰ Flexible scheduling for any event time</li>
              </ul>
            </div>
            <div className="features-image">
              <div className="feature-elements">
                <div className="feature-shape shape-1"></div>
                <div className="feature-shape shape-2"></div>
                <div className="feature-shape shape-3"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery">
        <div className="container">
          <h2 className="section-title">Our Work</h2>
          <p className="gallery-subtitle">
            Take a look at some of our recent events and signature cocktails
          </p>

          <div className="gallery-grid">
            {photos.map((photo) => (
              <div
                key={photo.id}
                className="gallery-item"
                onClick={() => setSelectedImage(photo)}
              >
                <img src={photo.src} alt={photo.alt} />
                <div className="gallery-overlay">
                  <p>{photo.alt}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="gallery-cta">
            <Link to="/media" className="btn btn-secondary">
              View Full Gallery
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Ready to Elevate Your Event?</h2>
          <p>
            Let us create the perfect cocktail experience for your next
            gathering.
          </p>
          <Link to="/quote" className="btn btn-primary btn-large">
            Request Your Quote Today
          </Link>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
            <img src={selectedImage.src} alt={selectedImage.alt} />
            <h3>{selectedImage.alt}</h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
